import { Stack } from "@mui/material";
import classNames from "classnames";
import Head from "next/head";
import React from "react";
import { AppSidebar } from "~/components/layout/sidebar/AppSidebar";
import { UserNotices } from "~/components/layout/UserNotices";

type Props = React.PropsWithChildren<{
  className?: string;
  title?: string;
  fluid?: boolean;
  fullscreen?: boolean;
  withUserNotices?: boolean;
}>;

export const Layout: React.FC<Props> = ({ className, title, children, withUserNotices = true }) => {
  const fullTitle = title ? `${title} · Figures` : null;

  return (
    <div className="flex h-full flex-col items-stretch justify-between">
      {fullTitle && (
        <Head>
          <title key="title">{fullTitle}</title>
        </Head>
      )}

      <Stack direction="row">
        <AppSidebar />

        <main
          className={classNames(className, {
            "relative min-w-0 flex-1": true,
          })}
        >
          {withUserNotices && <UserNotices className="sticky top-0 z-50 h-8 shadow" />}

          {children}
        </main>
      </Stack>
    </div>
  );
};
